









import { Component, Vue, Prop } from "vue-property-decorator";
import request from "../models/request";

@Component({
	name: "el-upload",
})
export default class ElUpload extends Vue {
	@Prop({ default: () => `_id${Math.random() * 10000}` })
	id: string;

	@Prop()
	label: string;

	@Prop()
	description: string;

	@Prop()
	value: string;

	@Prop()
	validator: Function;

	fileName: string = "Anexar";

	async uploadFile(file) {
		this.fileName = "Enviando...";
		const uploadResult = await request.uploadFile(file);
		this.fileName = file.name;
		this.$emit("input", uploadResult.uuid);
	}

	processFileEvent(event) {
		const { files } = event.target;
		if (files && files.length > 0) {
			const file = files[0];
			this.uploadFile(file)
				.catch((error) => {
					console.error(error);
					this.fileName = "Arquivo inválido";
					this.$swal({ icon: "error", title: "Arquivo inválido", text: "Verifique o formato e tamanho do arquivo (máx. 10 MB)" });
				});
		}
	}
}
